import { Price } from './Price'

export interface ProductPrice {
  netPrice: Price
  unitPrice: Price
  netFullPrice?: Price
  unitFullPrice?: Price
}

export enum ProductType {
  FRAMES = 'FRAME',
  PRESCRIPTION_SUNGLASSES = 'PRESCRIPTION_SUNGLASSES',
  PRESCRIPTION_LENS = 'PRESCRIPTION_LENS',
  SINGLE_VISION_LENS = 'SINGLE_VISION_LENS',
  BIFOCAL_LENS = 'BIFOCAL_LENS',
  PHOTOCHROMATIC_TINT = 'PHOTOCHROMATIC_TINT',
  TINTING = 'TINTING',
  ANTI_REFLECTIVE_TREATMENT = 'ANTI_REFLECTIVE_TREATMENT',
  PROGRESSIVE_LENS = 'PROGRESSIVE_LENS',
  PRESCRIPTION_CONTACT_LENS = 'PRESCRIPTION_CONTACT_LENS',
  COLORED_PLANO_CONTACT_LENS = 'COLORED_PLANO_CONTACT_LENS',
  SUNGLASSES = 'SUNGLASSES',
  ACCESSORIES = 'ACCESSORIES',
  SOLUTIONS = 'SOLUTIONS',
  ELECTRONICS = 'ELECTRONICS',
  OTHER = 'OTHER',
}

export type ProductTypesEligibility = {
  productTypesEligibility: {
    productType: ProductType
    benefitAvailability: 'SUPPORTED' | 'NOT_SUPPORTED'
  }[]
}

export interface VariantsAvailable {
  baseCurve: string[]
  diameter: string[]
}

export interface ProductBundle {
  id: string
  sku: string
  name: string
  brand: string
  prescription: ProductPrescription
  imageURL: string
  quantity: number
  cartProducts: Product[]
  variantsAvailable: VariantsAvailable
  totalPrice: Price
  bundleId?: string
  claimable: boolean
  includedInPrescription: boolean
}

export interface Product {
  name: string
  sku: string
  claimProductTypes?: ProductType[]
  quantity: number
  price: ProductPrice

  // -- CL only attributes
  bodySite?: BodySite
  packSize?: string
  conscat?: string
  // -- end CL only attributes

  /**
   * Applicable for check-eligibility api only
   */
  insuranceEligible?: boolean
}

export enum BodySite {
  LEFT_EYE = 'LEFT_EYE',
  RIGHT_EYE = 'RIGHT_EYE',
}

export interface ProductPrescription {
  left?: ProductPrescriptionEye
  right?: ProductPrescriptionEye
}

export interface ProductPrescriptionEye {
  options: ProductPrescriptionOptions
}

export enum ContactLensFamily {
  SOFT = 'SOFT',
  RIGID = 'RIGID',
}

export enum LensCorrectionType {
  NEAR = 'NEAR',
  FAR = 'FAR',
  MULTIFOCAL = 'MULTIFOCAL',
  PLANO = 'PLANO',
}

export enum LensType {
  SPHERIC = 'SPHERIC',
  TORIC = 'TORIC',
  MULTIFOCAL_PROGRESSIVE = 'MULTIFOCAL_PROGRESSIVE',
}

export enum ContactLensRenewalType {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
}

export interface ExtraPrescriptionAttributes {
  brand?: string
  style?: string
  manufacturer?: string
  contactLensFamily?: ContactLensFamily
  lensType?: LensType
  renewal?: ContactLensRenewalType
}

export interface ProductPrescriptionOptions extends ExtraPrescriptionAttributes {
  baseCurve?: string
  power?: string
  diameter?: string
  cylinder?: string
  axis?: string
  add?: string
  sphere?: string
  dominance?: string
  monoPupillaryDistance?: string
  pupillaryDistance?: string
  correctionType?: LensCorrectionType
  coloredContactLens?: boolean
  colour?: string
}

export enum EligibleProductStatus {
  PENDING = 'PENDING',
  ELIGIBLE = 'ELIGIBLE',
  NOT_ELIGIBLE = 'NOT_ELIGIBLE',
  NA = 'NA',
}

export type CartBundle = {
  cartId: string
  orderSubtotal: Price
  shippingCosts: Price
  products: ProductBundle[]
}
